<div class="p-field" *ngIf="formControl">
  <label for="wardGeoId">{{ 'Xã/phường'|translate }}</label>
  <p-dropdown id="wardGeoId" [options]="counties" [filter]="true" [formControl]="formControl"
              [showClear]="true" placeholder="-"></p-dropdown>
</div>
